import { ReactNode } from 'react'
import styled from 'styled-components'

import { Flex, Text } from '@percent/lemonade'

import { OrganisationProfile } from '../../types/organisationProfile.types'
import { OrganisationDetails } from '../OrganisationDetails/OrganisationDetails'
import { OrganisationProfileHeader } from '../OrganisationProfileHeader/OrganisationProfileHeader'

// Hand-rolled rather than CardDashboard: its padding would inset the header's band.
const Card = styled.div`
  ${({ theme }) => `
    overflow: hidden;
    border-radius: ${theme.radii.container};
    background-color: ${theme.semantic.backgroundSecondary};
  `}
`

const Body = styled(Flex)`
  ${({ theme }) => `
    padding: ${theme.spacing.l};
  `}
`

// Lemonade's Text is a span, so it inherits text-align from here.
const Description = styled.div`
  align-self: center;
  max-width: 80%;
  text-align: center;
`

export type OrganisationProfileCardProps = {
  profile: OrganisationProfile
  children?: ReactNode
}

export function OrganisationProfileCard({
  profile,
  children,
}: Readonly<OrganisationProfileCardProps>) {
  return (
    <Card data-testid="organisation-profile-card">
      <OrganisationProfileHeader profile={profile} />
      <Body direction="column" gap={40}>
        {profile.organisation.description && (
          <Description>
            <Text size="large">{profile.organisation.description}</Text>
          </Description>
        )}
        <OrganisationDetails organisation={profile.organisation} />
        {children}
      </Body>
    </Card>
  )
}
